import { Dialog } from 'primereact/dialog';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Toast } from 'reactstrap';
import ExhibitonTopbar from './ExhibitonTopbar';
import { Colors } from 'chart.js';
import { Button } from 'primereact/button';
import { CustomAddArtworks, CustomGaleria, CustomSearch, ExhibitionCarousel2, MuseumCarousel2 } from '../../components';
import { FileUpload } from 'primereact/fileupload';
import utils from '../../constants/utils';
import FileService from '../../service/FileService';
import Constants from '../../constants/Constants';
import ExhibitionService from '../../service/ExhibitionService';
import eventBus from '../../common/EventBus';

export const SecondExhibitionPage = (props) => {
    console.log("SecondExhibitionPage", props);
    const { t } = useTranslation();

    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);
    const [searchVisible, setSearchVisible] = useState(false);
    const [file, setFile] = useState();
    const [addArtworkVisible, setAddArtworkVisible] = useState(false);
    const [newExhibits, setNewExhibits] = useState([]);


    useEffect(() => {
        loadNewExhibits();        
    }, []);
    const onFileSelect = (props) => {
        setFile(props.files[0])
        console.log("onFileSelect", props);
    };


    const chooseOptions = { icon: 'fas fa-cloud-arrow-up file-upload-icon p-button-header', iconOnly: true, padding: 0 };

    const clear = () => {
        console.log("clear");

    }

    const loadNewExhibits = async () => {
        setNewExhibits([]);
        ExhibitionService.inquireNewExhibits( ).then(
            (response) => {
                console.log("inquireNewExhibits", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireNewExhibits", response?.data?.data?.dataList)
                    setNewExhibits(response?.data?.data?.dataList);
                }
            },
            (error) => {

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireExhibitByStatus logout******")
                    eventBus.dispatch("logout", props);
                } else {
                    props.toast.current?.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );

    }

    const renderArtworkContent = () => {
        return (



            <div className="flex flex-row align-items-top justify-content-between hide-scroolbar " style={{ top: 0, bottom: 0, position: "absolute", width: "99%" }}>
                <div className="flex flex-column align-items-center justify-content-start pr-5 " style={{ paddingTop: "100px", width: "100%" }}>

                    <CustomSearch setDialogVisible={setSearchVisible}
                        clear={clear}
                        width={"33%"}
                        placeholder={t("exhibition_text_search")}
                    ></CustomSearch>

                    <RenderArtWorks></RenderArtWorks>
                </div>


            </div>
        );
    };
    const RenderArtWorks = () => {
        return (
            <div className='pt-5  p-3'>

                <div>
                    <CustomGaleria RenderAddPanel={RenderAddPanel} hasAction={true} artworks={props.artworks} labelStyle={{ color: "#F7F7F7" }} onAction={props.addSelectedArtworks}></CustomGaleria>
                </div>


            </div>
        )

    }
    const RenderAddPanel = () => {
        console.log();

        return (
            <div className="flex align-items-center align-content-center justify-content-center col-12 md:col-6 m-2 mb-6"
                style={{ borderRadius: 20, width: 275, height: 225, backgroundColor: "#B0B0B0" }}
            >
                <Button icon="fas fa-cloud-arrow-up" className={"p-button-rounded p-button-header"}
                    onClick={() => setAddArtworkVisible(true)}>

                </Button>
            </div>
        )
    }
    const addArtwork = () => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={addArtworkVisible} position={'top'} onHide={() => setAddArtworkVisible(false)} className={'search-dialog'} headerClassName='search-dialog-header' contentClassName='search-dialog-content' >

                <CustomAddArtworks toast={props.toast} setDialogVisible={setAddArtworkVisible} {...props}
                    clear={clear}
                ></CustomAddArtworks>




            </Dialog>

        )


    }
    const renderExhibitionInfo = () => {
        return (
            <div className='m-3'>
                <div className='flex justify-content-between'
                    style={{}}
                >
                    <div style={{
                        flexDirection: 'row',
                        display: 'flex',
                        background: 'rgba(0,0,0, 0.65)',
                        boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.20)',
                        borderRadius: 20,
                        backdropFilter: 'blur(10px)',
                        padding: 2,
                        paddingRight: 5,
                        paddingLeft: 5,
                        alignItems: 'center',

                    }}>

                        <div style={{
                            width: 25, height: 25, borderRadius: 30,
                            backgroundImage: `url(${FileService.inquireFilePath(props?.profileImage)})`,
                        }}
                        />
                        <div className='font-white p-2' style={{ paddingLeft: 5, color: 'black', fontSize: 14, fontWeight: '400', wordWrap: 'break-word', textAlign: 'center' }}>  {props.firstName + " " + props.lastName}</div>
                    </div>
                    <Button icon="fa-regular fa-heart" className={props?.favoriteId ? "p-button-rounded mr-2 mb-2" : "p-button-rounded p-button-header mr-2 mb-2"}
                        onClick={() => {
                            if (props.favoriteId)
                                props.onRemoveFavorite(props.favoriteId);
                            else
                                props.onAddFavorite(Constants.entityNames.exhibition)
                        }}
                    />
                </div>
                <div className="grid align-items-start  justify-content-start pt-5" >

                    <div className='col-12 md:col-7  ' >
                        <span className="block text-6xl  mb-1  p-2">
                            {props?.exhibitionName}
                        </span>
                        <span className="block text-1xl  mb-1 p-2">
                            {utils.formatDate(props?.startDate) + '-' + utils.formatDate(props?.endDate)}
                        </span>
                        <span className="block text-2xl  mb-1  p-2">
                            {props?.exhibitionDescr}
                        </span>
                    </div>
                    <div className='col-12 md:col-5 justify-content-end' >

                        <div className='grid mr-2 align-items-center' style={{ float: "right", }}>

                            {
                                props.selectedArtists.map((item, index) => {
                                    return (

                                        <div style={{
                                            key: index,
                                            flexDirection: 'row',
                                            display: 'flex',
                                            background: 'rgba(0,0,0, 0.65)',
                                            boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.20)',
                                            borderRadius: 20,
                                            backdropFilter: 'blur(10px)',
                                            padding: 2,
                                            paddingRight: 5,
                                            paddingLeft: 5,
                                            alignItems: 'center',

                                        }}>
                                            <div style={{
                                                width: 25, height: 25, borderRadius: 30,
                                                backgroundImage: `url(${FileService.inquireFilePath(item?.profileImage)})`,
                                            }}
                                            />
                                            <div className='font-white p-2' style={{ paddingLeft: 5, color: 'black', fontSize: 14, fontWeight: '400', wordWrap: 'break-word', textAlign: 'center' }}>   {item?.ownerName}</div>
                                        </div>
                                    )
                                })

                            }
                        </div>
                    </div>
                </div>


                <div className="text-3xl  mb-3 pt-5"  >
                    {t('landing_header3')}
                    <ExhibitionCarousel2 data={newExhibits}></ExhibitionCarousel2>
                </div>
            </div>

        )
    }
    return (
        <div className='surface-exhibiton-header' style={{ backgroundColor: props.isEditable ? "#1C1C1C" : '#fff', height: "100vh" }}>
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>
            <div className='root-exhibiton scroll' style={{}}>
                <div className="grid grid-nogutter surface-exhibiton-main text-800 p-1">
                    <div className="surface-exhibiton justify-content-center align-items-center"  >

                        {props.isEditable && renderArtworkContent()}
                        {!props.isEditable && renderExhibitionInfo()}

                    </div>

                </div>
            </div>
            {addArtwork()}
        </div>
    );
}